module.exports = __webpack_public_path__ + "static/media/giphyx.cbfdc8d8.png";